(function () {
  function createCtoPaginationFix(config) {
    const { ctoPaginatedDataScriptId, sectionId, prod_option_obj, prod_option, prod_option1, prod_option2, compareIndex } = config || {};

    if (!ctoPaginatedDataScriptId || !sectionId || !Array.isArray(prod_option_obj) || !Array.isArray(prod_option)) {
      return {
        loadRemainingPaginatedProducts: async function () {
          return [];
        },
      };
    }

    const loadedVariantIds = new Set(prod_option_obj.map((item) => item.variant_id));
    const sortIndex = compareIndex || {};

    function sortProdOptionsByCompareIndex() {
      prod_option.sort(function (a, b) {
        var a_parts = a.option_new.split("|!");
        var b_parts = b.option_new.split("|!");
        for (var i = 0; i < Math.min(a_parts.length, b_parts.length); i++) {
          var a_item = a_parts[i];
          var b_item = b_parts[i];
          var a_index = sortIndex[a_item];
          var b_index = sortIndex[b_item];
          if (a_index !== undefined && b_index !== undefined) {
            if (a_index < b_index) {
              return -1;
            } else if (a_index > b_index) {
              return 1;
            }
          } else if (a_index !== undefined) {
            return -1;
          } else if (b_index !== undefined) {
            return 1;
          }
        }
        return a_parts.length - b_parts.length;
      });
    }
    sortProdOptionsByCompareIndex();

    function appendPaginatedProducts(products) {
      if (!Array.isArray(products) || products.length === 0) {
        return;
      }

      products.forEach(function (productEntry) {
        if (!productEntry || !productEntry.variant_id || loadedVariantIds.has(productEntry.variant_id)) {
          return;
        }

        loadedVariantIds.add(productEntry.variant_id);

        prod_option_obj.push({
          variant_id: productEntry.variant_id,
          price_amount: productEntry.price_amount,
          price_format: productEntry.price_format,
          nmp_html: productEntry.nmp_html,
          options: productEntry.options || {},
        });

        prod_option1[productEntry.option] = productEntry.available;

        prod_option.push({
          variant_id: productEntry.variant_id,
          option: productEntry.option,
          option_new: productEntry.option_new,
          product_opt1: productEntry.available,
          available: productEntry.available,
          url: productEntry.url,
          full_url: productEntry.full_url,
          id: productEntry.id,
          product_id: productEntry.product_id,
          product_sku: productEntry.product_sku,
          product_title: productEntry.product_title,
          product_type: productEntry.product_type,
          product_price: productEntry.product_price,
          product_price_amount: productEntry.product_price_amount,
          productcomPrice: productEntry.productcomPrice,
        });

        if (Array.isArray(productEntry.option_tokens)) {
          productEntry.option_tokens.forEach(function (optionToken) {
            prod_option2.push(optionToken);
          });
        }
      });

      window.ctoAllProductOptions = prod_option_obj;
    }

    async function fetchCtoPaginatedProducts(pageParam, pageNumber) {
      const pageUrl = new URL(window.location.href);
      pageUrl.searchParams.set("section_id", sectionId);
      pageUrl.searchParams.set(pageParam, pageNumber);

      try {
        const response = await fetch(pageUrl.toString(), { credentials: "same-origin" });
        const sectionMarkup = await response.text();
        const parsedDocument = new DOMParser().parseFromString(sectionMarkup, "text/html");
        const payloadScript = parsedDocument.getElementById(ctoPaginatedDataScriptId);

        return JSON.parse(payloadScript.textContent.trim());
      } catch (error) {
        console.error("Failed to fetch CTO paginated products", pageNumber, error);
        return [];
      }
    }

    async function loadRemainingPaginatedProducts() {
      const payloadScript = document.getElementById(ctoPaginatedDataScriptId);
      const totalPages = Number(payloadScript.dataset.totalPages || 1);
      const currentPage = Number(payloadScript.dataset.currentPage || 1);
      const pageParam = payloadScript.dataset.pageParam;

      const pagesToLoad = [];
      for (let page = 1; page <= totalPages; page += 1) {
        if (page !== currentPage) {
          pagesToLoad.push(page);
        }
      }

      const pageResults = await Promise.all(
        pagesToLoad.map(function (pageNumber) {
          return fetchCtoPaginatedProducts(pageParam, pageNumber);
        }),
      );

      pageResults.forEach(function (pageProducts) {
        appendPaginatedProducts(pageProducts);
      });

      sortProdOptionsByCompareIndex();
      return pageResults;
    }

    return {
      loadRemainingPaginatedProducts: loadRemainingPaginatedProducts,
    };
  }

  window.ctoPaginationFix = createCtoPaginationFix;
})();
